import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import {quarantinedFilesMetaInfo} from '@/column-header/response_actions/quarantined-files-meta'
import {networkRestrictionsMetaInfo} from '@/column-header/response_actions/network-restrictions-meta'
import {OrderByEnum} from '@/constants/orderby.constants'
import {
  TRAIL_MITIGATION_REQ,
  TRAIL_MITIGATION_REQ_SUCCESS,
  TRAIL_MITIGATION_REQ_ERROR,
  BULK_TRAIL_MITIGATION_REQ,
  BULK_TRAIL_MITIGATION_REQ_SUCCESS,
  BULK_TRAIL_MITIGATION_REQ_ERROR,
  BULK_TRAIL_REOPEN_MITIGATED_REQ,
  BULK_TRAIL_REOPEN_MITIGATED_REQ_SUCCESS,
  BULK_TRAIL_REOPEN_MITIGATED_REQ_ERROR,
  TRAIL_RESPONSE_ACTION_REQ,
  TRAIL_RESPONSE_ACTION_SUCCESS,
  TRAIL_RESPONSE_ACTION_ERROR,
  TRAIL_RESPONSE_IOC_ACTION_REQ,
  TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS,
  TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR,
  BULK_TRAIL_RESPONSE_IOC_ACTION_REQ,
  BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS,
  BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR,
  TRAIL_RESPONSE_QUARANTINED_FILES_REQ,
  TRAIL_RESPONSE_QUARANTINED_FILES_SUCCESS,
  TRAIL_RESPONSE_QUARANTINED_FILES_ERROR,
  TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ,
  TRAIL_RESPONSE_BLOCKED_NETWORKS_SUCCESS,
  TRAIL_RESPONSE_BLOCKED_NETWORKS_ERROR,
  NETWORK_VIEW_PREFERENCES_REQ,
  SAVE_NETWORK_VIEW_PREFERENCES,
  QUARANTINED_FILES_VIEW_PREFERENCES_REQ,
  SAVE_QUARANTINED_FILES_VIEW_PREFERENCES
} from './trailsinfo.type'

const state = {
  trailMitigationStatus: '',
  trailResponseActionStatus: '',
  trailResponseQuarantinedFiles: {},
  trailResponseQuarantinedFilesStatus: '',
  trailResponseBlockedNetworks: {},
  trailResponseBlockedNetworksStatus: '',
  networkPreferences: [],
  quarantinedFilePreferences: []
}

const getters = {
  trailMitigationStatus: state => state.trailMitigationStatus,
  trailResponseActionStatus: state => state.trailResponseActionStatus,
  trailResponseQuarantinedFiles: state => state.trailResponseQuarantinedFiles,
  trailResponseQuarantinedFilesStatus: state => state.trailResponseQuarantinedFilesStatus,
  trailResponseBlockedNetworks: state => state.trailResponseBlockedNetworks,
  trailResponseBlockedNetworksStatus: state => state.trailResponseBlockedNetworksStatus,
  networkPreferences: state => state.networkPreferences,
  quarantinedFilePreferences: state => state.quarantinedFilePreferences
}

// Best Practice - updates state
const mutations = {
  [TRAIL_MITIGATION_REQ]: state => {
    state.trailMitigationStatus = 'inprogress'
  },
  [TRAIL_MITIGATION_REQ_SUCCESS]: state => {
    state.trailMitigationStatus = 'saved'
  },
  [TRAIL_MITIGATION_REQ_ERROR]: state => {
    state.trailMitigationStatus = 'failed'
  },
  [BULK_TRAIL_MITIGATION_REQ]: state => {
    state.trailMitigationStatus = 'inprogress'
  },
  [BULK_TRAIL_MITIGATION_REQ_SUCCESS]: state => {
    state.trailMitigationStatus = 'saved'
  },
  [BULK_TRAIL_MITIGATION_REQ_ERROR]: state => {
    state.trailMitigationStatus = 'failed'
  },
  [BULK_TRAIL_REOPEN_MITIGATED_REQ]: state => {
    state.trailMitigationStatus = 'inprogress'
  },
  [BULK_TRAIL_REOPEN_MITIGATED_REQ_SUCCESS]: state => {
    state.trailMitigationStatus = 'saved'
  },
  [BULK_TRAIL_REOPEN_MITIGATED_REQ_ERROR]: state => {
    state.trailMitigationStatus = 'failed'
  },
  [TRAIL_RESPONSE_ACTION_REQ]: state => {
    state.trailResponseActionStatus = 'inprogress'
  },
  [TRAIL_RESPONSE_ACTION_SUCCESS]: state => {
    state.trailResponseActionStatus = 'completed'
  },
  [TRAIL_RESPONSE_ACTION_ERROR]: state => {
    state.trailResponseActionStatus = 'failed'
  },
  [TRAIL_RESPONSE_IOC_ACTION_REQ]: state => {
    state.trailResponseActionStatus = 'inprogress'
  },
  [TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS]: state => {
    state.trailResponseActionStatus = 'completed'
  },
  [TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR]: state => {
    state.trailResponseActionStatus = 'failed'
  },
  [BULK_TRAIL_RESPONSE_IOC_ACTION_REQ]: state => {
    state.trailResponseActionStatus = 'inprogress'
  },
  [BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS]: state => {
    state.trailResponseActionStatus = 'completed'
  },
  [BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR]: state => {
    state.trailResponseActionStatus = 'failed'
  },
  [TRAIL_RESPONSE_QUARANTINED_FILES_REQ]: state => {
    state.trailResponseQuarantinedFilesStatus = 'inprogress'
  },
  [TRAIL_RESPONSE_QUARANTINED_FILES_SUCCESS]: (state, data) => {
    state.trailResponseQuarantinedFiles = data
    state.trailResponseQuarantinedFilesStatus = 'completed'
  },
  [TRAIL_RESPONSE_QUARANTINED_FILES_ERROR]: state => {
    state.trailResponseQuarantinedFilesStatus = 'failed'
  },
  [TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ]: state => {
    state.trailResponseBlockedNetworksStatus = 'inprogress'
  },
  [TRAIL_RESPONSE_BLOCKED_NETWORKS_SUCCESS]: (state, data) => {
    state.trailResponseBlockedNetworks = data
    state.trailResponseBlockedNetworksStatus = 'completed'
  },
  [TRAIL_RESPONSE_BLOCKED_NETWORKS_ERROR]: state => {
    state.trailResponseBlockedNetworksStatus = 'failed'
  },
  [NETWORK_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.networkPreferences = data
  },
  [QUARANTINED_FILES_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.quarantinedFilePreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [NETWORK_VIEW_PREFERENCES_REQ](context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({data}) => {
          let currUserNetworkPrefs = data.find(pref => {
            return pref.tbl_id === 14 && pref.user_id === uid
          })
          context.commit(NETWORK_VIEW_PREFERENCES_REQ, currUserNetworkPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_NETWORK_VIEW_PREFERENCES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [QUARANTINED_FILES_VIEW_PREFERENCES_REQ](context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({data}) => {
          let currUserQuarantinedFilesPrefs = data.find(pref => {
            return pref.tbl_id === 15 && pref.user_id === uid
          })
          context.commit(QUARANTINED_FILES_VIEW_PREFERENCES_REQ, currUserQuarantinedFilesPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_QUARANTINED_FILES_VIEW_PREFERENCES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },

  [TRAIL_MITIGATION_REQ](context, trail) {
    let trailIdEncoded = encodeURIComponent(trail.trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_MITIGATION_REQ)
      ApiRest()
        .post(`/trails/${trailIdEncoded}/mitigate`, {
          assigned_from: trail.assignFrom,
          owner_id: trail.assignTo
        })
        .then(({data}) => {
          context.commit(TRAIL_MITIGATION_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_MITIGATION_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [BULK_TRAIL_MITIGATION_REQ](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(BULK_TRAIL_MITIGATION_REQ)
      ApiRest()
        .post(`/trails/bulkmitigate`, {
          trails: payload.trails,
          assigned_from: payload.assignFrom,
          owner_id: payload.assignTo
        })
        .then(({data}) => {
          context.commit(BULK_TRAIL_MITIGATION_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(BULK_TRAIL_MITIGATION_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [BULK_TRAIL_REOPEN_MITIGATED_REQ](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(BULK_TRAIL_REOPEN_MITIGATED_REQ)
      ApiRest()
        .post(`/trails/trailinfo/collectionreopen`, {
          trails: payload.trails,
          assigned_from: payload.assignFrom,
          owner_id: payload.assignTo
        })
        .then(({data}) => {
          context.commit(BULK_TRAIL_REOPEN_MITIGATED_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(BULK_TRAIL_REOPEN_MITIGATED_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_RESPONSE_ACTION_REQ](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_RESPONSE_ACTION_REQ)
      ApiRest()
        .post('/actions', payload)
        .then(({data}) => {
          context.commit(TRAIL_RESPONSE_ACTION_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_RESPONSE_ACTION_ERROR)
          reject(errMsg)
        })
    })
  },
  [TRAIL_RESPONSE_IOC_ACTION_REQ](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_RESPONSE_IOC_ACTION_REQ)
      ApiRest()
        .post(`/ioc/${payload.ioc_hash}/mark`, payload)
        .then(({data}) => {
          context.commit(TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR)
          reject(errMsg)
        })
    })
  },
  [BULK_TRAIL_RESPONSE_IOC_ACTION_REQ](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(BULK_TRAIL_RESPONSE_IOC_ACTION_REQ)
      ApiRest()
        .post(`/ioc/bulkmark`, {iocs: payload})
        .then(({data}) => {
          context.commit(BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR)
          reject(errMsg)
        })
    })
  },
  [TRAIL_RESPONSE_QUARANTINED_FILES_REQ](context, hours) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_RESPONSE_QUARANTINED_FILES_REQ)
      ApiRest()
        .get(`/actions/quarantinedfiles/${hours}`, hours)
        .then(({data}) => {
          let agentList = context.rootState.agents.agentList.models
          let collection = new IQCollection(
            data.map(item => {
              let host = {}
              let parsed = item.action.split('@@@')
              if (!_.isEmpty(agentList)) {
                host = _.find(agentList, {
                  agentId: item.agentId
                })
              }
              return {
                linkLabel: 'View Progression',
                parentTrailHash: item.parentTrailHash,
                agentId: item.agentId,
                hostname: host.hostname || item.agentId,
                recommendationHash: item.iocHash,
                recoIdx: item.recoIdx,
                action: item.action,
                error: item.error,
                active: parsed[0] === 'quarantine-file',
                status: parsed[0] === 'quarantine-file' ? 'restored' : 'quarantined', // status is opposite of next action
                os: parsed[1].toUpperCase(),
                file: parsed[3],
                timestamp: item.timestamp
              }
            }),
            {attributes: quarantinedFilesMetaInfo.meta.columns},
            {defaultSort: 'hostname', sortOrder: OrderByEnum.ASC}
          )
          context.commit(TRAIL_RESPONSE_QUARANTINED_FILES_SUCCESS, collection)
          resolve(collection)
        })
        .catch(errMsg => {
          context.commit(TRAIL_RESPONSE_QUARANTINED_FILES_ERROR)
          reject(errMsg)
        })
    })
  },
  [TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ](context, hours) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ)
      ApiRest()
        .get(`/actions/blockednetworks/${hours}`, hours)
        .then(({data}) => {
          let agentList = context.rootState.agents.agentList.models

          let collection = new IQCollection(
            data.map(item => {
              let host = {}
              let parsed = item.action.split('@@@')
              if (!_.isEmpty(agentList)) {
                host = _.find(agentList, {
                  agentId: item.agentId
                })
              }
              return {
                linkLabel: 'View Progression',
                parentTrailHash: item.parentTrailHash,
                agentId: item.agentId,
                hostname: host.hostname || item.agentId,
                recommendationHash: item.iocHash,
                recoIdx: item.recoIdx,
                action: item.action,
                error: item.error,
                active: parsed[0] === 'block-network',
                status: parsed[0] === 'block-network' ? 'off' : 'on', // status is opposite of next action
                ip: parsed[1],
                port: parsed[2],
                type: parsed[3].toUpperCase(),
                timestamp: item.timestamp
              }
            }),
            {attributes: networkRestrictionsMetaInfo.meta.columns},
            {defaultSort: 'hostname', sortOrder: OrderByEnum.ASC}
          )
          context.commit(TRAIL_RESPONSE_BLOCKED_NETWORKS_SUCCESS, collection)
          resolve(collection)
        })
        .catch(errMsg => {
          context.commit(TRAIL_RESPONSE_BLOCKED_NETWORKS_ERROR)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailmitigation.module.js